/*@flow*/
import type { Element } from 'react';
import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import toast from 'lib/toast';
import hash from 'lib/hash';
import type { LocalsT } from 'lib/proforma/types';
import useContextState from 'comps/Left2/useContextState';
import useCommands from 'comps/Left2/useCommands';

export default (props: LocalsT): Element<'div'> => {
  const s = useContextState();
  const cmd = useCommands();
  const marker = s.decks.get('marker');
  const { value, attrs, path } = props;
  const { name } = attrs;
  const [theGeom, setGeom] = useState(value);
  const [isPristine, setPristine] = useState(true);
  const [isUpdating, setUpdating] = useState(false);

  useEffect(() => {
    if (isPristine && value) {
      setPristine(false);
      setGeom(value);
    }
  }, [value]);

  useEffect(() => {
    const map = $('.CDB-Map').get(0);
    $('.modal').css(
      'cssText',
      `display: ${isUpdating ? 'none !important' : 'block'}`
    );
    $('.modal-backdrop').css(
      'cssText',
      `display: ${isUpdating ? 'none !important' : 'block'}`
    );
    const cursor = isUpdating ? 'crosshair' : 'default';
    map && $(map).css('cursor', cursor);

    if (isUpdating) {
      cmd.closePanel();
      toast('Click anywhere on the map.');
    }
  }, [isUpdating]);

  useEffect(() => {
    if (!isUpdating) return;
    if (!marker) return;
    const latlon = marker.get('latlon');
    if (!latlon) return;
    toast('Updated location.');
    const [lat, lon] = latlon.toJS();
    const wkt = `POINT (${lon} ${lat})`;
    setGeom(wkt);
    props.onChange(wkt);
    setUpdating(false);
  }, [hash(marker)]);

  return (
    <div
      className={cx(
        'form-group form-group-depth-2',
        `form-group-${path.join('-')}`
      )}
    >
      <div>
        <input type="hidden" name={name} value={theGeom || ''} />
        <button
          className="btn btn-link btn-normalcase btn-sm p-0"
          onClick={(e) => {
            e.preventDefault();
            setUpdating(true);
          }}
        >
          {theGeom ? 'Update' : 'Select'} location
        </button>
      </div>
    </div>
  );
};
